import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { pricingPlanBenefitsData } from "../../data";

const PlanBenefits = () => {
  return (
    <section className="py-4 py-lg-5 my-lg-3">
      <Container fluid className="px-0">
        <ContentBox className="p-4 p-lg-5 bg-white rounded-4">
          <Header>
            <Title className="text-light-black">Included in Both Plans</Title>
            <Subtitle>Every Fleetsimplify owner gets these benefits</Subtitle>
          </Header>
          <Row className="g-4">
            {pricingPlanBenefitsData.map((benefit) => (
              <Col key={benefit.id} xs={12} sm={6} md={6} lg={4}>
                <BenefitCard>
                  <IconWrapper className="d-flex align-items-center justify-content-center gap-2">
                    <span>{benefit.icon}</span>
                    <CardTitle>{benefit.title}</CardTitle>
                  </IconWrapper>
                  <CardDescription>{benefit.description}</CardDescription>
                </BenefitCard>
              </Col>
            ))}
          </Row>
        </ContentBox>
      </Container>
    </section>
  );
};

export default PlanBenefits;

const ContentBox = styled.div`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #7fb5fcff;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 16px;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #5f6368;
  margin: 0;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const BenefitCard = styled.div`
  background: #fafafa;
  border-radius: 12px;
  padding: 30px 24px;
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
  }
`;

const IconWrapper = styled.div`
  font-size: 24px;
  margin-bottom: 12px;

  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: #5f6368;
  margin: 12px 0 0 0;
  line-height: 1.6;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;
